import { render } from "./ds-nazn-house-view.vue?vue&type=template&id=0335a306&scoped=true"
import script from "./ds-nazn-house-view.vue?vue&type=script&setup=true&lang=js"
export * from "./ds-nazn-house-view.vue?vue&type=script&setup=true&lang=js"

import "./ds-nazn-house-view.vue?vue&type=style&index=0&id=0335a306&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0335a306"],['__file',"src/views/tep/tep-nsi/ds-nazn-house-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0335a306"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0335a306', __exports__)) {
    api.reload('0335a306', __exports__)
  }
  
  module.hot.accept("./ds-nazn-house-view.vue?vue&type=template&id=0335a306&scoped=true", () => {
    api.rerender('0335a306', render)
  })

}


export default __exports__